var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12072",
    "data-name": "Group 12072",
    transform: "translate(-960 -1994)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1353",
    "data-name": "Rectangle 1353",
    width: 44,
    height: 42,
    rx: 10,
    transform: "translate(960 1994)",
    fill: "#3fecc6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12069",
    "data-name": "Group 12069",
    transform: "translate(-26 -59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10037",
    "data-name": "Path 10037",
    d: "M75.7,81.55H71.25A2.686,2.686,0,0,0,75.7,81.55Z",
    transform: "translate(934.231 2002.233)",
    fill: "#030a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10038",
    "data-name": "Path 10038",
    d: "M95.254,73.23A7.725,7.725,0,0,1,95,74.948S96.354,73.605,95.254,73.23Z",
    transform: "translate(919.217 2007.492)",
    fill: "#030a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10039",
    "data-name": "Path 10039",
    d: "M58.889,74.948a7.725,7.725,0,0,1-.243-1.718C57.546,73.605,58.889,74.948,58.889,74.948Z",
    transform: "translate(942.474 2007.492)",
    fill: "#030a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10040",
    "data-name": "Path 10040",
    d: "M82.409,67.18a1.438,1.438,0,0,0-1.379,1.232,1.863,1.863,0,0,1,2.762,0A1.452,1.452,0,0,0,82.409,67.18Z",
    transform: "translate(928.048 2011.317)",
    fill: "#030a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10041",
    "data-name": "Path 10041",
    d: "M68.392,68.412a1.39,1.39,0,0,0-2.762,0A1.862,1.862,0,0,1,68.392,68.412Z",
    transform: "translate(937.785 2011.317)",
    fill: "#030a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10042",
    "data-name": "Path 10042",
    d: "M94.948,34.642a3.525,3.525,0,0,1-1.42-2.332C92.535,33.84,94.948,34.642,94.948,34.642Z",
    transform: "translate(920.3 2033.361)",
    fill: "#030a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10043",
    "data-name": "Path 10043",
    d: "M66.267,29.06s.324.978-1.287,2.361C64.987,31.421,67.959,29.987,66.267,29.06Z",
    transform: "translate(938.194 2035.415)",
    fill: "#030a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10044",
    "data-name": "Path 10044",
    d: "M70.406,40.732a16.88,16.88,0,0,1-1.979,1.983,8.132,8.132,0,0,0,1.751-3.428c.026-.11.052-.221.074-.331a.226.226,0,0,1,.018-.107c.026-.143.048-.291.066-.434s.026-.206.033-.309a9.8,9.8,0,0,0,.029-1.225,3.486,3.486,0,0,0-.033-.486c-.029-.32-.074-.633-.129-.938a1.455,1.455,0,0,0-.051-.276c-.044-.206-.092-.412-.143-.611l-.055-.21a13.51,13.51,0,0,0-1.56-3.557h0a4.782,4.782,0,0,1-.166,1.225c-.029.11-.059.217-.1.324s-.063.184-.1.272a5.463,5.463,0,0,1-.978,1.611,10.247,10.247,0,0,0-.074-3.833,7.39,7.39,0,0,0-.883-2.273l-.018-.037a4.094,4.094,0,0,0-.368-.515h0a5.267,5.267,0,0,1,.217,1.251,3.764,3.764,0,0,1,0,.452,3.877,3.877,0,0,1-.817,2.332,6.808,6.808,0,0,0-.7-4.274c-.066-.125-.132-.246-.206-.368s-.206-.342-.32-.508a13.425,13.425,0,0,0-5.15-4.134h0c.806.7,1.449,3.115-1.126,5.26s-2.148,4.072-2.148,4.072a4.7,4.7,0,0,1-1.019-3.112c-2.523,3.435-1.232,8-1.232,8a6.321,6.321,0,0,1-1.5-2.792,8.184,8.184,0,0,0,.644,8.265l-1.232-.861a8.875,8.875,0,0,0,4.723,4.447c-4.723-4.454-1.935-5.043-1.935-5.043.43-6.279,6.01-6.441,6.01-6.441a2.454,2.454,0,0,0,0,3.005,4.939,4.939,0,0,1,2.31-3.005,6.573,6.573,0,0,1,3.59,1.935l.022.029a5.6,5.6,0,0,1,.368.467l.085.118c.1.151.2.3.287.452a6.076,6.076,0,0,1,.386.8,6.724,6.724,0,0,1,.5,2.424,1.137,1.137,0,0,1,.853,1.519,5.017,5.017,0,0,1-.817,1.585c-.063.085-.125.173-.191.257-.3.394-.614.758-.9,1.063-.2.217-.368.4-.526.544h0l-.3.287h0a7.294,7.294,0,0,0,1.549-.736h0c.154-.1.3-.2.445-.309l.191-.147a7.326,7.326,0,0,0,.577-.508,8.214,8.214,0,0,0,2.019-3.178Z",
    transform: "translate(947.088 2039.67)",
    fill: "#030a34"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreen);
export default __webpack_public_path__ + "static/media/logo-green.097eb51fa1256a7e63f5654f620abf66.svg";
export { ForwardRef as ReactComponent };